import SelectableGridController from "../../selectable_grid/selectable_grid";

export default class extends SelectableGridController {
  handleRadioClick(event) {
    const radio = event.target;
    const img = radio.closest("label").querySelector("img");
    this.updatePreviewImage(img.src, img.alt);
    this.updateMobileItems(radio);
  }
}
